import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import ScrollSequence from "@/components/ScrollSequence";
import Marquee from "@/components/Marquee";
import Portfolio from "@/components/Portfolio";
import ServiceMap from "@/components/ServiceMap";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      smoothTouch: false,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App min-h-screen bg-navy-950 font-sans text-slate-200 antialiased">
      <Navbar />
      <main>
        <ScrollSequence />
        <Marquee />
        <Portfolio />
        <ServiceMap />
        <Footer />
      </main>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#061224",
            border: "1px solid rgba(212,175,55,0.35)",
            color: "#F8FAFC",
          },
        }}
      />
    </div>
  );
}

export default App;
